import { IMAGE_BASE_URL } from "../../app_constants";

const getImageUrl = (imageFile) => {
    if (!imageFile) return "";
    const trimmed = String(imageFile).trim();

    if (trimmed.startsWith("data:") || trimmed.startsWith("blob:")) {
        return trimmed;
    }

    if (trimmed.startsWith("http")) {
        return encodeURI(trimmed);
    }

    if (trimmed.startsWith("/job-default-images/")) {
        return encodeURI("https://api.opportunitybankhk.org" + trimmed);
    }

    return encodeURI(IMAGE_BASE_URL + trimmed);
};

export default getImageUrl;
